import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import CalendarIcon from '@mui/icons-material/DateRangeRounded';
import RightArrowIcon from '@mui/icons-material/KeyboardArrowRight';
import OpenRequestIcon from '@mui/icons-material/Diversity2Outlined';
import MoneyIcon from '@mui/icons-material/LocalAtmRounded';
import TableIcon from '@mui/icons-material/TableChartRounded';
import Text from '../../../components/Text'
import { DashboardCard } from './Home.styles'
import { colors, spacing } from '../../../styles/_var'
import TextWithIcon from '../../../components/TextWithIcon';
import { Link } from 'react-router-dom';
import { routes } from '../../../utils/constants';
import PeopleIcon from '@mui/icons-material/GroupAddOutlined';
import OpenRequestDrawer from './OpenRequestDrawer';

type DashboardActionCard = {
  id: string
  label: string
  icon: React.ReactElement
  bgColor: string
  className: string
  route?: string
  onClick?: () => void
}

const DashboardActions = React.memo(() => {
  const [openDateRequestDrawer, setOpenDateRequestDrawer] = React.useState(false)
  const toggleOpenRequestDrawer = () => setOpenDateRequestDrawer(!openDateRequestDrawer)

  const actionCards: DashboardActionCard[] = [
    {
      id: 'group-activity',
      label: 'Group Activity',
      icon: <PeopleIcon />,
      bgColor: colors.pink,
      className: 'jr-group-activity',
      route: routes.PLAN_ACTIVITY,
    },
    {
      id: 'plan-date',
      label: 'Plan a date',
      icon: <CalendarIcon />,
      bgColor: colors.lightGreen,
      className: 'jr-plan-date',
      route: routes.ALL_FRIENDS,
    },
    {
      id: 'open-invite',
      label: 'Open Invite',
      icon: <OpenRequestIcon />,
      bgColor: colors.lightyellow,
      className: 'jr-open-invite',
      onClick: toggleOpenRequestDrawer,
    },
    {
      id: 'buck-breaker',
      label: 'Buck Breaker',
      icon: <MoneyIcon />,
      bgColor: colors.lightergrey,
      className: 'jr-open-invite',
      route: routes.BUCK_BREAKERS,
    },
    {
      id: 'scoreboard',
      label: 'Scoreboard',
      icon: <TableIcon />,
      bgColor: colors.verylightPrimary,
      className: 'jr-scoreboard',
      route: routes.SCOREBOARD_INDEX,
    },
  ]

  const renderCard = (card: DashboardActionCard) => {
    const cardContent = (
      <Box padding={spacing.xxs} bgcolor={card.bgColor} className={card.className} onClick={card.onClick}>
        {React.cloneElement(card.icon, {
          fontSize: 'large' as const,
          sx: { display: 'block', marginBottom: spacing.xxs }
        })}
        <TextWithIcon 
          weight="semibold" 
          after 
          justifyContent='space-between' 
          icon={<RightArrowIcon />}
        >
          {card.label}
        </TextWithIcon>
      </Box>
    )

    return (
      <Grid item xs={6} key={card.id}>
        <DashboardCard elevation={2}>
          {card.route ? (
            <Link to={card.route}>
              {cardContent}
            </Link>
          ) : (
            cardContent
          )}
        </DashboardCard>
      </Grid>
    )
  }

  return (
    <>
      <Box mt={3}>
        <Text mt={3} mb={2}>What do you want to do today?</Text>
        <Grid container spacing={2}>
          {actionCards.map(renderCard)}
        </Grid>
      </Box>
      <OpenRequestDrawer isOpen={openDateRequestDrawer} closeDrawer={toggleOpenRequestDrawer} />
    </>
  )
})

export default DashboardActions
